import OpenResponsesSummary from '@src/openResponses/components/OpenResponsesSummary';
import DetailAssessmentsList from '@src/openResponses/components/DetailAssessmentsList';

const OpenResponsesPage = () => {
  return (
    <>
      <OpenResponsesSummary />
      <DetailAssessmentsList />
    </>
  );
};

export default OpenResponsesPage;
